import {Component,OnInit} from "@angular/core";
import {ConfigurationSoap} from "@domain/admin/parametre/api/soap/configuration-soap";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {ApiSoapService} from "@services/admin/parametre/api/api-soap.service";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction, TypeAction} from "@share/component/floating-button/floating-button";
import {handleResult} from "@share/utils/handle-result";

/**
 * Onglet API SOAP
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'api-soap'},
    templateUrl: './api-soap.component.html'
})
export class ApiSoapComponent implements OnInit {
    /** Configuration Soap concernée */
    configurationSoap: ConfigurationSoap;

    /** Visibilité des champs password */
    isPasswordVisible: boolean = false;

    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService,
                private toastrService: ToastrService,
                private apiSoapService: ApiSoapService) {}

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Récupération de la configuration
        this.apiSoapService.consultParam().subscribe((result) => {
            //Chargement de la configuration dans la variable locale
            this.configurationSoap = new ConfigurationSoap(result.data?.configuration);
        });

        //Ajout des actions possibles
        this.listeActions.next([
            {
                type: TypeAction.PRIMARY,
                icone: 'nio icon-sauvegarde',
                libelle: 'global.actions.enregistrer',
                doAction: () => this.saveParam()
            }
        ]);
    }

    /**
     * Copie du mot de passe dans le presse-papiers
     */
    copyToClipboard() {
        //Copie du mot de passe dans le presse-papiers
        navigator.clipboard.writeText(this.configurationSoap.passwordEncrypted).then(() => {
            //Message de confirmation
            this.toastrService.success(this.translateService.instant('admin.parametres.api.soap.copieAvecSucces'));
        }).catch(() => {
            //Méthode de fallback pour les vieux navigateurs éventuels
            const textarea = document.createElement('textarea');
            textarea.value = this.configurationSoap.passwordEncrypted;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            //Message de confirmation
            this.toastrService.success(this.translateService.instant('admin.parametres.api.soap.copieAvecSucces'));
        });
    }

    /**
     * Bascule de la visibilité du mot de passe
     */
    togglePasswordVisibility() {
        this.isPasswordVisible = !this.isPasswordVisible;
    }

    /**
     * Enregistrement de la configuration
     */
    saveParam() {
        //Enregistrement de la configuration
        this.apiSoapService.saveParam(this.configurationSoap)
            .pipe(handleResult(this.translateService,this.toastrService,
                'global.success.enregistrement','global.errors.enregistrement'))
            .subscribe((result) => {
            //Mise à jour du nouveau mot de passe crypté
            this.configurationSoap.passwordEncrypted = result.data?.passwordEncrypted;
        });
    }
}
